import { Suspense } from 'react'

import { Authentication } from 'Common/auth/types'
import { hasFeature } from 'Common/environment'

import MainNavigation from './MainNavigation'
import MainNavigationNew from './MainNavigationNew'

type Props = {
    auth: Authentication
    logout: () => void
}

export default function MainNavigationContainer(props: Readonly<Props>) {
    const { auth, logout } = props

    return (
        <Suspense fallback={null}>
            {hasFeature('newNavigation') ? (
                <MainNavigationNew auth={auth} logout={logout} />
            ) : (
                <MainNavigation auth={auth} />
            )}
        </Suspense>
    )
}
